import { SENSITIVE_USER_FIELDS } from "./file";

/**
 * Validates data against a Zod schema using safeParse.
 * Logs validation errors to the console in all environments.
 * Always returns the original data regardless of validation outcome.
 *
 * @param {import("zod").ZodSchema} schema
 * @param {*} data
 * @param {string} label - Identifier for logging (e.g. "getJob", "socket:extract-progress")
 * @returns {*} The original data, unchanged
 */
export const validateResponse = (schema, data, label) => {
	const result = schema.safeParse(data);
	if (!result.success) {
		console.warn(`[schema] ${label}: validation failed`, result.error.issues);
	}

	// Check for sensitive field leaks in user objects within file responses
	if (data && data.result && Array.isArray(data.result)) {
		data.result.forEach((item) => {
			if (item && item.createdByUser) {
				const leaked = SENSITIVE_USER_FIELDS.filter(
					(field) => field in item.createdByUser
				);
				if (leaked.length > 0) {
					console.warn(
						`[security] ${label}: API response contains sensitive user fields: ${leaked.join(", ")}. ` +
							`This is a backend issue — these fields should be excluded from the query.`
					);
				}
			}
		});
	}

	return data;
};
